import {
  // createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";
// import { fetchCount } from './counterAPI';

const initialState = {
  status: "loading",
  user: {
    displayName: "Loading...",
    limit: 20
  },
  token: "",
  logged: false,
  roles: [],
  claims: [],
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
// export const incrementAsync = createAsyncThunk(
//   "counter/fetchCount",
//   async (amount) => {
//     // const response = await fetchCount(amount);
//     // // The value we return becomes the `fulfilled` action payload
//     // return response.data;
//   }
// );

export const authSlice = createSlice({
  name: "auth",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    loginAction: (state, action) => {
      console.log("action", action);
      state.user = {
        ...action.payload.user,
        uid: action.payload.uid,
      };
      state.user.limit = action.payload.user.limit || 20
      state.status = action.payload.status;
      state.token = action.payload.token;
      state.roles = action.payload.roles;
      state.claims = action.payload.claims;
      state.logged = true;
    },
    updateProfileAction: (state, action) => {
      state.user = {
        ...action.payload.updated,
        uid: action.payload.uid,
      };
      state.status = action.payload.status;
    },
    updateFieldAction: (state, action) => {
      state.user = {
        ...state.user,
        ...action.payload.field,
      };
      state.status = action.payload.status;
    },
    authErrorAction: (state, action) => {
      state.status = action.payload.status;
    },
    claimsAction: (state, action) => {
      state.claims = action.payload.claims;
    },
    setLimitAction: (state, action) => {
      state.user.limit = action.payload.limit;
    },
    // Use the PayloadAction type to declare the contents of `action.payload`
    logoutAction: (state) => {
      state = initialState;
    },
  },
  // // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // // including actions generated by createAsyncThunk or in other slices.
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(incrementAsync.pending, (state) => {
  //       state.status = "loading";
  //     })
  //     .addCase(incrementAsync.fulfilled, (state, action) => {
  //       state.status = "idle";
  //       state.value += action.payload;
  //     });
  // },
});

export const {
  authErrorAction,
  claimsAction,
  loginAction,
  logoutAction,
  updateFieldAction,
  updateProfileAction,
  setLimitAction
} = authSlice.actions;

export const selectAuth = (state) => state.auth;

export default authSlice.reducer;
